import React from 'react';
import { t } from 'i18next';
import { DashboardSummary, DashboardSummaryCount, DashboardSummaryHeader, DashboardSummaryTitle } from '@/components/custom/dashboard';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';

export function DashboardSummaryCard(props) {
  const { title, count, link, route } = props;

  return (
    <DashboardSummary>
      <DashboardSummaryHeader>
        <DashboardSummaryTitle>{title || t('textsCommon.title')}</DashboardSummaryTitle>
      </DashboardSummaryHeader>

      <DashboardSummaryCount>{count || '0'}</DashboardSummaryCount>

      {route && link && (
        <Button
          variant="link"
          className="h-auto justify-start p-0"
          asChild
        >
          <Link to={route}>{link}</Link>
        </Button>
      )}
    </DashboardSummary>
  );
}
